import { Context } from '@/models/order-history/status/context/context'
import { OrderCancellationState } from '@spa/components/organisms/mypage/order/model/order-cancellation-state'
import { ForDefault } from '@spa/components/organisms/mypage/order/model/order-cancellation-state/commands/for-default'
import { CreateOrderCancellationStateCommand } from '@spa/components/organisms/mypage/order/model/order-cancellation-state/create-command'

interface ApplicableContext extends Context {
  paymentType: 'np-postpay'
}

/**
 * @internal モジュールの外部からはgetOrderCancellationStateを利用すること
 */
export class ForNpPostpay extends CreateOrderCancellationStateCommand<ApplicableContext> {
  shouldApply(context: Context): context is ApplicableContext {
    return context.paymentType === 'np-postpay'
  }
  protected createState(context: ApplicableContext): OrderCancellationState {
    if (context.engineStatus === 'payment-requested') {
      return {
        isCancellable: false,
        messageForNotCancellable: 'ご注文情報の与信審査中はキャンセルできません。',
      }
    }

    /**
     * 再注文待ち (payment-error) は既存仕様を踏襲しキャンセル可とする
     * @see https://github.com/Everforth/growthpalette-front/issues/7843#issuecomment-2005781698
     */
    if (context.engineStatus === 'payment-error') {
      return {
        isCancellable: true,
      }
    }

    // デフォルトにフォールバック
    return new ForDefault().execute(context)
  }
}
